import initialState from '../initialState';
import {
    LOADING,
    GET_ALL_INVOICES
} from '../../actions/types/invoices';

export default (state = initialState.invoices, action) => {
    switch (action.type) {
        case LOADING: {
            return {
                ...state,
                loading: action.state
            };
        }

        case GET_ALL_INVOICES: {
            return {
                ...state,
                items: action.invoices
            };
        }

        default:
            return state;
    }
};